import React from 'react';
import { Row, Col } from 'antd';
import Innovation from '../../assets/images/about/innovation.png';
import Integrity from '../../assets/images/about/integrity.png';
import Respect from '../../assets/images/about/respect.png';
import teamWork from '../../assets/images/about/teamwork.png';
import SEO from '../../components/SEO';

import profileImage from '../../assets/images/profile.png';

const Yomafleet = () => {
    // const history = useHistory();

    return (
        <div className="aboutContainer">
            <SEO title="About Yoma Fleet" description="Build a better Myanmar for its People" path="about-us" />
            <Row justify="center" gutter={48} className="aboutSubContainer">
                <Col span={24}>
                    <h1 className="heroTitle text-center">Build a better Myanmar for its People</h1>
                </Col>
            </Row>

            <Row justify="center" gutter={48} className="aboutSubContainer">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                >
                    <h2 className="blockTitle text-center">Our Values</h2>
                </Col>

                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 4 }}
                    xl={{ span: 4 }}
                    xxl={{ span: 4 }}
                >
                    <img className="aboutImage" src={Innovation} alt="Innovation" />
                    <h3 className="blockPara text-center">Innovation</h3>
                </Col>

                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 4 }}
                    xl={{ span: 4 }}
                    xxl={{ span: 4 }}
                >
                    <img className="aboutImage" src={Integrity} alt="Integrity" />
                    <h3 className="blockPara text-center">Integrity</h3>
                </Col>

                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 4 }}
                    xl={{ span: 4 }}
                    xxl={{ span: 4 }}
                >
                    <img className="aboutImage" src={Respect} alt="Respect" />
                    <h3 className="blockPara text-center">Respect</h3>
                </Col>

                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 4 }}
                    xl={{ span: 4 }}
                    xxl={{ span: 4 }}
                >
                    <img className="aboutImage" src={teamWork} alt="Teamwork" />
                    <h3 className="blockPara text-center">Teamwork</h3>
                </Col>
            </Row>

            <Row justify="center" gutter={48} className="aboutSubContainer">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                >
                    <h2 className="blockTitle text-center">ABOUT US</h2>
                </Col>

                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                >
                    <div className="aboutTeamProfile">
                        <p className="aboutTeamPosition">
                            Yoma Fleet Limited was established in 2014 to provide vehicle rental services in Myanmar and
                            has expanded to financial leasing of vehicles and equipment under the Yoma Financial
                            Services arm of the Yoma Group umbrella (Yoma Strategic Holdings Ltd). Currently, Yoma Fleet
                            holds the largest rental fleet in Myanmar at USD 37 million AUM in 2022.
                        </p>
                    </div>
                </Col>
            </Row>

            <Row justify="center" gutter={48} className="aboutSubContainer">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                >
                    <h2 className="blockTitle text-center">A brief profile of Yoma Fleet Limited</h2>
                </Col>

                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 4 }}
                    xl={{ span: 4 }}
                    xxl={{ span: 4 }}
                >
                    <div className="aboutTeamProfile">
                        <p className="aboutTeamName">6</p>
                        <p className="aboutTeamPosition">BRANDS</p>
                    </div>
                </Col>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 4 }}
                    xl={{ span: 4 }}
                    xxl={{ span: 4 }}
                >
                    <div className="aboutTeamProfile">
                        <p className="aboutTeamName">1600+</p>
                        <p className="aboutTeamPosition">FLEET</p>
                    </div>
                </Col>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 4 }}
                    xl={{ span: 4 }}
                    xxl={{ span: 4 }}
                >
                    <div className="aboutTeamProfile">
                        <p className="aboutTeamName">$37m</p>
                        <p className="aboutTeamPosition">AUM</p>
                    </div>
                </Col>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 4 }}
                    xl={{ span: 4 }}
                    xxl={{ span: 4 }}
                >
                    <div className="aboutTeamProfile">
                        <p className="aboutTeamName">10</p>
                        <p className="aboutTeamPosition">LOCATIONS</p>
                    </div>
                </Col>
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 4 }}
                    xl={{ span: 4 }}
                    xxl={{ span: 4 }}
                >
                    <div className="aboutTeamProfile">
                        <p className="aboutTeamName">110</p>
                        <p className="aboutTeamPosition">EMPLOYEES</p>
                    </div>
                </Col>
            </Row>

            <Row justify="center" gutter={48} className="aboutSubContainer">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                >
                    <h2 className="blockTitle text-center">Yoma Group</h2>
                </Col>

                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                >
                    <div className="aboutTeamProfile">
                        <p className="aboutTeamPosition">
                            Yoma Group consists of Yoma Strategic Holdings Limited and First Myanmar Investment Public
                            Company Limited.
                        </p>
                    </div>
                </Col>
            </Row>

            <Row justify="center" gutter={48} className="aboutSubContainer">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                >
                    <h2 className="blockTitle text-center">Yoma Strategic Holdings Limited</h2>
                </Col>

                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                >
                    <div className="aboutTeamProfile">
                        <p className="aboutTeamPosition">
                            Yoma Strategic Holdings is listed on the mainboard of the Singapore Stock Exchange. Yoma
                            Strategic is a leading Myanmar focused conglomerate with businesses in the Real Estate,
                            Financial Services, Consumer and Automotive Sectors alongside a portfolio of strategic
                            investments. Yoma Fleet Limited is operated under the Financial Services arm of{' '}
                            <a href="https://yomastrategic.com/" target="_blank">
                                <u>Yoma Strategic Holdings</u>
                            </a>
                            .
                        </p>
                    </div>
                </Col>
            </Row>

            <Row justify="center" gutter={48} className="aboutSubContainer">
                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                >
                    <h2 className="blockTitle text-center">First Myanmar Investment Public Company Limited</h2>
                </Col>

                <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 24 }}
                    xl={{ span: 24 }}
                    xxl={{ span: 24 }}
                >
                    <div className="aboutTeamProfile">
                        <p className="aboutTeamPosition">
                            <a href="https://fmi.com.mm/" target="_blank">
                                <u>First Myanmar Investment Public Company Limited (FMI)</u>
                            </a>{' '}
                            is one of Myanmar’s largest public companies with more than 8,600 shareholders and has a
                            track record of profitability over the past 27 years. FMI’s strength lies in its strategic
                            diversification, professional management and corporate governance and transparency.
                        </p>
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default Yomafleet;
